module.exports = __webpack_public_path__ + "static/media/banner.94b4dd6e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/bodor/images/banner.webp
// module id = 582
// module chunks = 0